import React from "react";
import Layout3 from "components/layout/Layout3";
import Director from "./director";

const RegionalDirector = (props) => {
  return (
    <Layout3>
      <Director {...props} />
    </Layout3>
  );
};

export default RegionalDirector;
